import { shape, string, func } from 'prop-types';

export default shape({
  label: string.isRequired,
  onClick: func.isRequired
});
